import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { FooterComponent } from './footer.component'
import { LinkModule } from '../components/shared/link/link.module'
import { NavigationNode } from '../navigation/mb-navigation.service'
import { CmsComponentsBaseModule } from '../components/cms-components-base.module'
import { PictureModule } from '../components/shared/picture/picture.module'
import { Image } from '../components/types'

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CmsComponentsBaseModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SimpleBannerComponent: {
          component: FooterComponent
        }
      }
    }),
    LinkModule,
    I18nModule,
    PictureModule,
  ],
  exports: [FooterComponent]
})
export class FooterModule {}

export interface SocialMediaNode extends NavigationNode {
  image: Image;
}
